import React from "react"
import { useTranslation } from "react-i18next"

import { Button } from "components"
import TdListCard from "./TdListCard"
import classes from "./TdList.module.scss"

const TdList = props => {
  const {
    noTables,
    thisLevelTables,
    setTables,
    setLayout,
    setSelectedTable
  } = props

  const [t] = useTranslation()

  const handlePress = () => {
    setLayout(prev =>
      prev === "list"
        ? noTables ? "options" : "form"
        : "list"
    )
  }

  return (
    <div className={classes["list"]}>
      <div className={classes["header"]}>
        <Button
          color="success"
          onClick={handlePress}
        >
          {noTables ? t("افزودن") : t("افزودن_میز")}
        </Button>
      </div>
      {thisLevelTables.map((table, tableIndex) =>
        <TdListCard
          key={table.tableNumber}
          table={table}
          tableIndex={tableIndex}
          setLayout={setLayout}
          setTables={setTables}
          setSelectedTable={setSelectedTable}
        />
      )}
    </div>
  )
}

export default TdList